export default function PHP_get_charset() {
  return (
    <div>
      <h1>PHP_get_charset</h1>
    </div>
  );
}
